export default __webpack_public_path__ + "static/media/icon_todos_off.ce7d0bb7.svg";